import { render, staticRenderFns } from "./VisitorList.vue?vue&type=template&id=450fb981"
import script from "./VisitorList.vue?vue&type=script&lang=js"
export * from "./VisitorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports